<template>
     <highcharts :options="options" class="h-full w-full" ref="pieIdChart" ></highcharts>
</template>

<script>

    export default {
        props: {
            chartOptions: {
                type: Object,
                default () {
                    return {
                        percent: 50,
                        current_amount: '15000'
                    }
                }
            },
            chartTitle: {
                type: String
            }
        },
        data:function(){
            return{
                options:{
                    chart: {
                        type: 'pie',
                        margin:[0,0,0,0],
                        spacingBottom:0,
                        spacingRight:0,
                        spacingLeft:0,
                        spacingtop:0,
                        backgroundColor:'rgba(0,0,0,0)',

                        // height: 150
                    },
                    credits:{
                        enabled:false
                    },
                    legend: {
                        enabled:false,
                    },
                    title: {
                        text: '',
                        // this.chartOptions.current_amount,
                        style: {
                            'color': '#285e61',
                            'fontSize': '1.3em'
                        },
                        align: 'center',
                        verticalAlign: 'top',
                        y: 40
                        
                    },
                    subtitle: {
                        text: '',
                        // `${this.chartOptions.previous_amount}€`,
                        style: { 
                            'color': "#FFFFFF",
                            'fontSize': "1.7em"
                         },
                        align: 'center',
                        verticalAlign: 'middle',
                        y: 15
                        
                    },

                    tooltip: {
                         enabled:false,
                        // headerFormat: '<b>{point.x}</b><br/>',
                        //pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                                distance: 0,
                                style: {
                                    fontWeight: 'bold',
                                    color: 'white'
                                }
                            },
                           // center: ['50%', '50%'],
                            //showInLegend: true
                            colors: ['#4fd1c5', '#234e52'],
                            //size: '110%'
                        },
                        
                    },
                   
                    colors:['rgb(74, 241, 177)','rgba(0, 0, 0, 0.33)'],
                    series: [
                        {
                            name: '',
                            data: [],
                            innerSize: '95%',
                            outerSize: '110%',
                            borderWidth:0,
                        }
                    ]

                }
            }
        },
        mounted() {
            this.setSeries(this.chartOptions.percent)
        },
        watch:{
            data(n,o){
                this.setSeries(n)
            }
        },
        methods:{
            setSeries(n){
                var chart = this.$refs['pieIdChart'].chart;
                chart.series[0].setData([n,100-n]);
                setTimeout( () => {
                    chart.reflow()
                },200)
            }
        }
    }
</script>
<style>
    .chart-wrap{
        margin: auto;
        height: 100% !important;
        width: 100% !important;
        position: relative;
    }
    .chart-wrap .highcharts-container{
        height: 100% !important;
        width: 100% !important;
    }

    .chart-wrap>div{
        height: 100% !important;
        width: 100% !important;                
    }
    
    .chart-wrap>div svg{
        height: 100% !important;
        width: 100% !important;
    }

    .topTitle{
        top: 68%
    }
</style>
